<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M11.8125 2.1875H2.1875C1.95544 2.1875 1.73288 2.27969 1.56878 2.44378C1.40469 2.60788 1.3125 2.83044 1.3125 3.0625V10.9375C1.3125 11.1696 1.40469 11.3921 1.56878 11.5562C1.73288 11.7203 1.95544 11.8125 2.1875 11.8125H11.8125C12.0446 11.8125 12.2671 11.7203 12.4312 11.5562C12.5953 11.3921 12.6875 11.1696 12.6875 10.9375V3.0625C12.6875 2.83044 12.5953 2.60788 12.4312 2.44378C12.2671 2.27969 12.0446 2.1875 11.8125 2.1875ZM2.1875 3.0625H4.375V10.9375H2.1875V3.0625ZM11.8125 10.9375H5.25V3.0625H11.8125V10.9375Z"
      fill="#1F1F1F"
    />
  </svg>
</template>
